import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import Button from "../../../../../components/common/button/Button";
import Input from "../../../../../components/common/input/Input";
import { Form } from "react-bootstrap";
import styles from "./AdminCreateUsers.scss";
import {
  required,
  alphaSymbolicSpace,
  email
} from "../../../../../utils/forms/validators";
import { ADMIN_CREATE_USERS_FORM } from "../../../../../actions/admin.actions";

const firstName = alphaSymbolicSpace("Please enter a valid first name.");
const lastName = alphaSymbolicSpace("Please enter a valid last name.");
const emailVal = email("Please enter a valid email address.");

class AdminCreateUsers extends Component {
  render() {
    const { invalid, submitting, pristine } = this.props;

    return (
      <section className={styles.adminCreateUsers}>
        <div className={styles.content}>
          <h2 className={styles.title}>Create Admin Account</h2>
          <Form onSubmit={this.props.handleSubmit}>
            <div className={styles.form}>
              <Field
                name="first_name"
                type="text"
                placeholder="First Name"
                component={Input}
                validate={[required, firstName]}
                autoFocus={true}
              />
              <Field
                name="last_name"
                type="text"
                placeholder="Last Name"
                component={Input}
                validate={[required, lastName]}
              />
              <Field
                name="email"
                type="text"
                placeholder="Email Address"
                component={Input}
                validate={[required, emailVal]}
              />
              <div className={styles.dividerDouble} />
              <Button
                isDisabled={invalid || submitting || pristine}
                isPrimary
                type="submit"
                size="large"
                label="Create"
              />
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

export default (AdminCreateUsers = reduxForm({
  form: ADMIN_CREATE_USERS_FORM
})(AdminCreateUsers));



// WEBPACK FOOTER //
// ./src/routes/admin/new/users/components/AdminCreateUsers.js